module["exports"] = ["#{street_title} #{street_suffix}"];